import React from 'react';
import Transition from 'react-transition-group/Transition';

import Modal from 'common/components/modals/Modal';
import SuccessBanner from './SuccessBanner';

const overlayFadeInDuration = 150;
const hideDelay = overlayFadeInDuration + 1700;
const exitDuration = 500;

const backgroundStyles = {
  entering: {
    opacity: 1.0,
    transform: 'translateY(0)',
  },
  exiting: {
    opacity: 0.0,
    transform: 'translateY(0)',
  },
  exited: {
    opacity: 0.0,
    transform: 'translateY(50px)',
  },
};

const backgroundDefaultStyle = {
  transitionProperty: 'opacity, transform',
  transitionDuration: `${overlayFadeInDuration}ms`,
  transitionTimingFunction: 'ease-out',
};

const modalDefaultStyle = {
  overlay: {
    background: 'none',
  },
};

const modalStyles = {
  exited: {
    overlay: {
      overflow: 'hidden',
      // we can't use display: none because it will cause the
      // transition of the inner contents to never happen
      width: 0,
      height: 0,
    },
  },
};

export default class AddToCartSuccessModal extends React.Component {
  state = {
    hasRenderedModal: false,
  };

  handleModalOpened = () => {
    this.setState({ hasRenderedModal: true });
  };

  closeModal = () => {
    this.setState({ hasRenderedModal: false });
    this.props.hide();
  };

  componentWillUnmount() {
    this.handleModalClosed();
  }

  render() {
    const { quantity } = this.props;
    const { hasRenderedModal } = this.state;
    const isOpen = quantity > 0;

    return (
      <Transition
        in={hasRenderedModal}
        onEntered={this.closeModal}
        timeout={{ enter: hideDelay, exit: exitDuration }}
      >
        {status => (
          <Modal
            canScrollLock={isOpen}
            style={{
              ...modalDefaultStyle,
              ...modalStyles[status],
            }}
            onAfterOpen={this.handleModalOpened}
            isOpen={isOpen}
            closable={false}
            bodyClassName="AddToCartSuccessModal__body"
            overlayClassName="AddToCartSuccessModal__overlay"
            className="AddToCartSuccessModal__content"
          >
            <div
              className="AddToCartSuccessModal__background"
              style={{
                ...backgroundDefaultStyle,
                ...backgroundStyles[status],
              }}
            />

            <SuccessBanner status={status} quantity={quantity} />
          </Modal>
        )}
      </Transition>
    );
  }
}
